/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StructuredContractResponse } from './StructuredContractResponse';
import {
    StructuredContractResponseFromJSON,
    StructuredContractResponseFromJSONTyped,
    StructuredContractResponseToJSON,
} from './StructuredContractResponse';

/**
 * 
 * @export
 * @interface GetPayerContractStructuredContract200Response
 */
export interface GetPayerContractStructuredContract200Response {
    /**
     * 
     * @type {StructuredContractResponse}
     * @memberof GetPayerContractStructuredContract200Response
     */
    data?: StructuredContractResponse;
}

/**
 * Check if a given object implements the GetPayerContractStructuredContract200Response interface.
 */
export function instanceOfGetPayerContractStructuredContract200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPayerContractStructuredContract200ResponseFromJSON(json: any): GetPayerContractStructuredContract200Response {
    return GetPayerContractStructuredContract200ResponseFromJSONTyped(json, false);
}

export function GetPayerContractStructuredContract200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayerContractStructuredContract200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : StructuredContractResponseFromJSON(json['data']),
    };
}

export function GetPayerContractStructuredContract200ResponseToJSON(value?: GetPayerContractStructuredContract200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': StructuredContractResponseToJSON(value.data),
    };
}

